import React from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import { Controller } from 'react-hook-form';
import { handleGetOnlyDate } from './InputDateInterval';
import * as S from './styles';
import * as Style from 'components/Style';

const { RangePicker } = DatePicker;
const dateFormat = 'DD/MM/YYYY';
const dateFormatMes = 'MM/YYYY';
const dateFormatAno = 'YYYY';

export const DateInterval = ({
  tipoPeriodo,
  label,
  errors,
  name,
  control,
  onChange,
  disabled,
  isClear,
  value,
  defaultValue,
  openChange,
  required,
}) => {
  const [data, setDate] = React.useState(value || defaultValue);

  const getOnlyDate = change => {
    handleGetOnlyDate(change, name, tipoPeriodo, setDate, onChange);
  };

  const getFormat = () => {
    if (tipoPeriodo === 'year') return dateFormatAno;
    if (tipoPeriodo === 'month') return dateFormatMes;
    return dateFormat;
  };

  const disabledDate = current => {
    return current && current._d.getFullYear() <= new Date('12/31/2021').getFullYear();
  };

  const onFocus = () => {
    setDate(null);
    onChange({
      target: { name: name, value: { dataInicio: null, dataFim: null } },
    });
  };

  return (
    <S.InputContain id="ComponenteDataInterval">
      {label && <S.Label>{label}</S.Label>}
      <Controller
        name={name}
        control={control}
        render={() => {
          return (
            <>
              <RangePicker
                picker={tipoPeriodo === '' ? 'date' : tipoPeriodo}
                name={name}
                disabled={[disabled, disabled]}
                onChange={change => getOnlyDate(change)}
                value={isClear ? null : data}
                onOpenChange={openChange}
                onFocus={onFocus}
                format={getFormat()}
                defaultPickerValue={defaultValue}
                data-testid="input Data Intervalo"
                disabledDate={disabledDate}
                required={required}
              />

              {errors && errors[name] && <Style.GlobalErro>{errors[name]?.message}</Style.GlobalErro>}
            </>
          );
        }}
      />
    </S.InputContain>
  );
};

DateInterval.propTypes = {
  tipoPeriodo: PropTypes.string,
  label: PropTypes.string,
  errors: PropTypes.object,
  name: PropTypes.string,
  control: PropTypes.object,
  onChange: PropTypes.func,
  disabled: PropTypes.bool,
  isClear: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.array,
  openChange: PropTypes.func,
  required: PropTypes.bool,
};

DateInterval.defaultProps = {
  tipoPeriodo: '',
  label: '',
  errors: {},
  name: '',
  control: {},
  onChange: () => {},
  disabled: false,
  isClear: false,
  value: '',
  defaultValue: null,
  openChange: () => {},
  required: false,
};

export default DateInterval;
